var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clickable has-border__bottom item-list-dashboard",on:{"click":_vm.click}},[_c('div',{staticClass:"file-item flex-row flex-left",staticStyle:{"padding":"5px 0px"}},[(
        _vm.type !== _vm.DASHBBOARD_TYPE.CV_TOI_GIAO &&
        _vm.type !== _vm.DASHBBOARD_TYPE.CV_DUOC_GIAO
      )?_c('i',{staticClass:"far fa-file color__link font-size__small margin-right-10"}):_c('div',{class:[
        'theDueDate',
        'margin-right-10',
        _vm.getDeadlineLvlClass(_vm.item.deadline) ]}),_vm._v(" "),_c('span',{class:_vm.item.isSeen ||
        _vm.type == _vm.DASHBBOARD_TYPE.CV_TOI_GIAO ||
        _vm.type == _vm.DASHBBOARD_TYPE.CV_DUOC_GIAO
          ? 'file-name text-overflow-document'
          : 'file-name text-overflow-document font-weight__bold'},[_vm._v(_vm._s(_vm.item.quote))])]),_vm._v(" "),_c('span',{class:_vm.item.isSeen ||
      _vm.type == _vm.DASHBBOARD_TYPE.CV_TOI_GIAO ||
      _vm.type == _vm.DASHBBOARD_TYPE.CV_DUOC_GIAO
        ? 'file-name text-overflow-document'
        : 'file-name text-overflow-document font-weight__bold',staticStyle:{"color":"rgb(136, 152, 170)"}},[_vm._v("\n    "+_vm._s(_vm.peopleTitle(_vm.item))+" "+_vm._s(_vm.timeTitle(_vm.item)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3830effb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/doc-dashboard-card-item.vue
// module id = uHUg
// module chunks = 89